import * as React from "react";

const ExternalLinkIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path
                d="M3 3.5V14.5H14V3.5H3ZM4 4.5H13V13.5H4V4.5ZM7 6V7H9.7815L5.14 11.6405L5.859 12.3595L10.5 7.7185V10.5H11.5V6H7Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default React.memo(ExternalLinkIcon);
